import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";

var _templateObject;

var _excluded = ["description"],
    _excluded2 = ["richtextImages"],
    _excluded3 = ["item", "Ul", "Ol", "Li", "RichTextImageRenderer"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef } from 'react';
import Image from 'next/legacy/image';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { Bold, Italic } from '@yoweb/ui/components/markdown';
import { Box } from '@yoweb/ui/components/Box';
import { Title, Text, Interactive } from '@yoweb/ui/components/typography';
import { th } from '@yoweb/ui/styles/utils/theme';
import { LineClamp } from '@yoweb/ui/components/LineClamp';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { CardCarouselFixed, useCarouselStepper } from '@poplar/components/CardCarouselFixed';
import { CardCarouselNav } from '@poplar/components/CardCarouselNav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Description = function Description(_ref) {
  var description = _ref.description,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    mt: "small4"
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Text, {
      weight: "bold",
      size: {
        _: 'md',
        md: 'sm'
      },
      children: /*#__PURE__*/_jsx(LineClamp, {
        lines: 1,
        children: description
      })
    })
  }));
};

var ResponsiveRichtextImages = function ResponsiveRichtextImages(_ref2) {
  var richtextImages = _ref2.richtextImages,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var isTiled = richtextImages.length > 1;
  return /*#__PURE__*/_jsx(RichTextImageContentRoot, _objectSpread(_objectSpread({
    isTiled: isTiled
  }, rest), {}, {
    children: richtextImages.map(function (imageInfos, idx) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _jsxs(ImageWrapper, {
          "data-testid": "pdp-richtext-image",
          children: [/*#__PURE__*/_jsx(TiledImageArea, {
            isTiled: isTiled,
            children: /*#__PURE__*/_jsx(Image, {
              src: imageInfos.imageUrl,
              alt: imageInfos.description,
              layout: "fill"
            })
          }), /*#__PURE__*/_jsx(Description, {
            description: imageInfos.description
          })]
        }, idx)
      );
    })
  }));
};

var breakpoints = [{
  width: 670,
  itemsToShow: 1
}, {
  width: 1100,
  itemsToShow: 1
}, {
  width: 1200,
  itemsToShow: 1
}];

var MobileCarousel = function MobileCarousel(_ref3) {
  var richtextImages = _ref3.richtextImages;
  var isTiled = richtextImages.length > 1;
  var carouselContainerRef = useRef(null);
  var totalItems = richtextImages.length;

  var _useCarouselStepper = useCarouselStepper(totalItems, carouselContainerRef, breakpoints),
      currentStep = _useCarouselStepper.currentStep,
      onNext = _useCarouselStepper.onNext,
      onPrevious = _useCarouselStepper.onPrevious,
      backwardEnabled = _useCarouselStepper.backwardEnabled,
      forwardEnabled = _useCarouselStepper.forwardEnabled;

  if (!isTiled) {
    return /*#__PURE__*/_jsx(ResponsiveRichtextImages, {
      richtextImages: richtextImages
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavWrapper, {
      children: /*#__PURE__*/_jsx(CardCarouselNav, {
        onNext: onNext,
        onPrevious: onPrevious,
        backwardEnabled: backwardEnabled,
        forwardEnabled: forwardEnabled
      })
    }), /*#__PURE__*/_jsx(CarouselWrapper, {
      ref: carouselContainerRef,
      children: /*#__PURE__*/_jsx(CardCarouselFixed, {
        step: currentStep,
        breakpoints: breakpoints,
        id: "pdp-mobile-image-carousel",
        cardGap: 16,
        itemWidth: 214,
        fluid: true,
        children: richtextImages.map(function (imageInfos, idx) {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _jsxs(FixedRatioImageWrapper, {
              width: 214,
              children: [/*#__PURE__*/_jsx(TiledImageArea, {
                isTiled: isTiled,
                children: /*#__PURE__*/_jsx(Image, {
                  src: imageInfos.imageUrl,
                  alt: imageInfos.description,
                  layout: "fill"
                })
              }), /*#__PURE__*/_jsx(Description, {
                description: imageInfos.description
              })]
            }, idx)
          );
        })
      })
    })]
  });
};

var NavWrapper = styled.div.withConfig({
  componentId: "sc-1o17lqm-0"
})(["display:flex;justify-content:flex-end;margin-top:", ";margin-bottom:", ";"], th.getSpace('normal1'), th.getSpace('small4'));
var CarouselWrapper = styled.div.withConfig({
  componentId: "sc-1o17lqm-1"
})(["display:block;overflow:hidden;width:100vw;max-width:calc(100vw - ", ");"], th.getSpace('normal4'));
var FixedRatioImageWrapper = styled.div.withConfig({
  componentId: "sc-1o17lqm-2"
})(["position:relative;aspect-ratio:'1 / 1';width:", ";height:auto;"], function (_ref4) {
  var width = _ref4.width;
  return pxToRem(width);
});
export var CompactRichTextImageContent = function CompactRichTextImageContent(_ref5) {
  var content = _ref5.content;
  var richtextImages = content.richtextImageInfosList;
  var isTiled = richtextImages.length > 1;
  var carouselContainerRef = useRef(null);
  var totalItems = richtextImages.length;

  var _useCarouselStepper2 = useCarouselStepper(totalItems, carouselContainerRef, breakpoints),
      currentStep = _useCarouselStepper2.currentStep,
      onNext = _useCarouselStepper2.onNext,
      onPrevious = _useCarouselStepper2.onPrevious,
      backwardEnabled = _useCarouselStepper2.backwardEnabled,
      forwardEnabled = _useCarouselStepper2.forwardEnabled;

  if (!isTiled) {
    return /*#__PURE__*/_jsx(ResponsiveRichtextImages, {
      richtextImages: richtextImages
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavWrapper, {
      children: /*#__PURE__*/_jsx(CardCarouselNav, {
        onNext: onNext,
        onPrevious: onPrevious,
        backwardEnabled: backwardEnabled,
        forwardEnabled: forwardEnabled
      })
    }), /*#__PURE__*/_jsx(FlyoutCarouselWrapper, {
      ref: carouselContainerRef,
      children: /*#__PURE__*/_jsx(CardCarouselFixed, {
        step: currentStep,
        breakpoints: breakpoints,
        id: "pdp-flyout-image-carousel",
        cardGap: 16,
        itemWidth: 365,
        fluid: true,
        children: richtextImages.map(function (imageInfos, idx) {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _jsxs(FixedRatioImageWrapper, {
              width: 365,
              children: [/*#__PURE__*/_jsx(TiledImageArea, {
                isTiled: isTiled,
                children: /*#__PURE__*/_jsx(Image, {
                  src: imageInfos.imageUrl,
                  alt: imageInfos.description,
                  layout: "fill"
                })
              }), /*#__PURE__*/_jsx(Description, {
                description: imageInfos.description
              })]
            }, idx)
          );
        })
      })
    })]
  });
};
var FlyoutCarouselWrapper = styled.div.withConfig({
  componentId: "sc-1o17lqm-3"
})(["display:block;overflow:hidden;width:calc(", " - ", ");max-width:calc(100vw - ", ");", ""], th.getSize('flyoutWidth'), th.getSpace('large2'), th.getSpace('large2'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    max-width: calc(", " - ", ");\n  "])), th.getSize('flyoutWidth'), th.getSpace('large2')));
export var FullPageRichTextImageContent = function FullPageRichTextImageContent(_ref6) {
  var content = _ref6.content;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RenderOn.MobileOnly, {
      children: /*#__PURE__*/_jsx(MobileCarousel, {
        richtextImages: content.richtextImageInfosList
      })
    }), /*#__PURE__*/_jsx(RenderOn.TabletAndDesktop, {
      children: /*#__PURE__*/_jsx(ResponsiveRichtextImages, {
        richtextImages: content.richtextImageInfosList,
        "data-testid": "pdp-fullpage-richtext-images"
      })
    })]
  });
};
var RichTextImageContentRoot = styled.div.withConfig({
  componentId: "sc-1o17lqm-4"
})(["display:grid;grid-template-columns:", ";gap:", ";row-gap:", ";position:relative;align-items:center;align-content:center;margin-top:", ";flex-wrap:wrap;"], function (_ref7) {
  var isTiled = _ref7.isTiled;
  return isTiled ? '1fr 1fr 1fr' : '1fr';
}, th.getSpace('normal1'), th.getSpace('normal2'), th.getSpace('normal2'));
var ImageWrapper = styled.div.withConfig({
  componentId: "sc-1o17lqm-5"
})(["width:100%;height:100%;"]);
var TiledImageArea = styled.div.withConfig({
  componentId: "sc-1o17lqm-6"
})(["position:relative;aspect-ratio:", ";width:100%;height:auto;border-radius:", ";overflow:hidden;"], function (_ref8) {
  var isTiled = _ref8.isTiled;
  return isTiled ? '1 / 1' : '3 / 2';
}, th.getRadii('small'));
var SpaceText = styled(Text).withConfig({
  componentId: "sc-1o17lqm-7"
})(["&&{margin-block:", ";}"], th.getSpace('small4'));
export var ProductPageRichTextContent = function ProductPageRichTextContent(_ref9) {
  var item = _ref9.item,
      Ul = _ref9.Ul,
      Ol = _ref9.Ol,
      Li = _ref9.Li,
      RichTextImageRenderer = _ref9.RichTextImageRenderer,
      boxProps = _objectWithoutProperties(_ref9, _excluded3);

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    mb: "medium2",
    "data-testid": "featured-richtext-block"
  }, boxProps), {}, {
    children: [item.markdownContent && /*#__PURE__*/_jsx(ReactMarkdown, {
      components: {
        p: function p(props) {
          return /*#__PURE__*/_jsx(Box, {
            mt: "small4",
            children: /*#__PURE__*/_jsx(Text, _objectSpread(_objectSpread({}, props), {}, {
              wordBreak: "break-word"
            }))
          });
        },
        h2: function h2(props) {
          return /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            children: /*#__PURE__*/_jsx(Title, _objectSpread(_objectSpread({
              size: "xs"
            }, props), {}, {
              wordBreak: "break-word"
            }))
          });
        },
        ul: function ul(props) {
          return /*#__PURE__*/_jsx(Ul, _objectSpread({}, props));
        },
        ol: function ol(props) {
          return /*#__PURE__*/_jsx(Ol, _objectSpread({}, props));
        },
        li: function li(props) {
          return Li ? /*#__PURE__*/_jsx(Li, _objectSpread({}, props)) : /*#__PURE__*/_jsx(SpaceText, _objectSpread({
            as: "li"
          }, props));
        },
        strong: function strong(props) {
          return /*#__PURE__*/_jsx(Bold, _objectSpread({}, props));
        },
        em: function em(props) {
          return /*#__PURE__*/_jsx(Italic, _objectSpread({}, props));
        },
        a: function a(props) {
          return /*#__PURE__*/_jsx(Interactive, _objectSpread({
            as: "a",
            textDecoration: "underline"
          }, props));
        }
      },
      remarkPlugins: [remarkGfm],
      children: item.markdownContent
    }), item.richtextImageContent && /*#__PURE__*/_jsx(RichTextImageRenderer, {
      content: item.richtextImageContent
    })]
  }));
};